import React from 'react'
import TopPanelMenu from 'components/TopPanelMenu'
import Limit from 'containers/Limit'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {getSelectedDateRange} from 'redux/modules/currentUser/selectors'
import Loader from 'components/Loader'
import {exportOrder} from 'redux/modules/orders/actions'
import classnames from 'classnames'

class AttributionExplorerMenu extends React.Component {
  static propTypes = {
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    exportOrder: PropTypes.func,
    filters: PropTypes.object,
    sessions: PropTypes.object
  }

  static contextTypes = {
    currency: PropTypes.string,
    timezone: PropTypes.string
  }

  state = {
    isLoading: false
  }

  render() {
    return (
      <div className='attribution-explorer-menu'>
        <TopPanelMenu
          items={[
            {
              to: '/attribution-explorer',
              title: 'Explorer',
              onlyActiveOnIndex: true
            },
            {to: '/attribution-explorer/findById', title: 'Search By ID'}
          ]}
        />
        {this.renderExportButton()}
      </div>
    )
  }

  renderExportButton() {
    const {isLoading} = this.state

    const className = classnames(
      'is-normal attribution-explorer-menu_button',
      {
        'is-loading': isLoading
      }
    )
    return (
      <Limit
        className='attribution-explorer-menu_button'
        limitKey='reports'
        action='create'
      >
        <button
          className={className}
          onClick={this.handleExport}
        >
          {isLoading ? (
            <>
              Export
              <Loader />
            </>
          ) : (
            'Export'
          )}
        </button>
      </Limit>
    )
  }

  handleExport = () => {
    const {currency, timezone} = this.context
    const {startDate, endDate, exportOrder, filters, sessions} = this.props

    if (this.state.isLoading) {
      return
    }

    this.setState({isLoading: true})
    exportOrder(
      startDate,
      endDate,
      currency,
      timezone,
      filters,
      sessions
    ).success(() => {
      console.log("exportOrder success")
      this.setState({isLoading: false})
    })
  }
}

const mapStateToProps = state => {
  const {startDate, endDate} = getSelectedDateRange(state)

  return {
    startDate,
    endDate,
    filters: state.orders.filters,
    sessions: state.orders.sessions
  }
}

const mapDispatchToProps = {
  exportOrder
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttributionExplorerMenu)



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/menu.js